'use client';

import { TextPassage } from '@petsmart-ui/sparky';

import type { FrequencyRecommendation } from '../model/frequencyRecommendation';
import { mapRecommendedFrequencyToAutoship } from '../model/mapRecommendedFrequency';

type SuggestedFrequencyProps = {
    result: FrequencyRecommendation;
};

export const SuggestedFrequency = ({ result }: SuggestedFrequencyProps) => {
    const { recommendedAutoshipFrequency, recommendedAutoshipFrequencyUnit } =
        mapRecommendedFrequencyToAutoship(result);
    const recommendedFrequencyLabel = `every ${recommendedAutoshipFrequency} ${recommendedAutoshipFrequencyUnit}`;

    return (
        <div className="frequency-calculator-drawer__result" data-testid="frequency-calculator-result">
            <TextPassage className="frequency-calculator-drawer__result-title">Suggested frequency</TextPassage>
            <div className="frequency-calculator-drawer__result-content">
                {result.source === 'calculated' && (
                    <TextPassage className="frequency-calculator-drawer__result-copy">
                        This bag should last about <strong>{result.frequencyDays}</strong> days.
                    </TextPassage>
                )}
                <TextPassage className="frequency-calculator-drawer__result-copy">
                    We recommend Autoship <strong>{recommendedFrequencyLabel}</strong>
                    {result.source === 'fallback' ? ' (most common).' : '.'}
                </TextPassage>
            </div>
            <TextPassage className="frequency-calculator-drawer__result-note">
                This is an estimate. You can adjust your Autoship frequency anytime based on your pet's needs.
            </TextPassage>
        </div>
    );
};
